module.exports = "/_next/static/media/126986730d1e905ed3bb6a3e11f6a7e7.svg";